<template>
  <div ref="app">
    <div class="success_icon">
      <i class="el-icon-check check-icon"></i>
      <span>绑定成功</span>
    </div>
    <div class="success_text">
      您已成功绑定<br />{{ className }}{{ studentInfo }}同学
    </div>
    <div class="qr">
      <img src="../assets/img/app_qr.jpg" />
      <div class="qr_title">京师成长</div>
      <div class="qr_title">长按识别二维码</div>
      <div class="qr_title">
        或微信搜索小程序“<span>京师成长</span>”登录小程序
      </div>
    </div>
    <div class="btn">
      <span>本班还有孩子</span>
      <span class="add_student" @click="navToBind">继续添加</span>
    </div>
  </div>
</template>
<script>
import '../assets/css/bind.css'
export default {
  data() {
    return {
      code: '',
      className: '',
      studentInfo: '',
      schoolId: '',
      schoolName: '',
      gradeId: '',
      classesId: ''
    }
  },
  created() {
    this.code = this.$route.query.code
    this.className = this.$route.query.className
    this.studentInfo = this.$route.query.studentInfo
    this.schoolId = this.$route.query.schoolId
    this.schoolName = this.$route.query.schoolName
    this.gradeId = this.$route.query.gradeId
    this.classesId = this.$route.query.classesId
  },
  methods: {
    navToBind() {
      this.$router.push({
        path: '/bindChild',
        query: {
          classesId: this.classesId
        }
      })
    }
  },
  mounted() {}
}
</script>
<style scoped>
#app {
  width: 100vw;
  height: 100vh;
  padding: 0.53rem 0.27rem 1.6rem 0.27rem;
  box-sizing: border-box;
}
.success_icon {
  margin-top: 1.33rem;
  font-size: 0.43rem !important;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}
.success_icon span {
  margin-left: 0.27rem;
  color: #333;
}
.success_text {
  margin-top: 0.53rem;
  font-size: 0.43rem !important;
  color: #333;
  text-align: center;
}
.qr {
  margin-top: 0.53rem;
  text-align: center;
}
.qr img {
  width: 5.33rem;
  height: 5.33rem;
}
.qr_title {
  font-size: 0.37rem !important;
}
.btn {
  margin-top: 0.8rem;
  font-size: 0.37rem !important;
  text-align: center;
}
.add_student {
  display: inline-block;
  width: 2.16rem;
  height: 0.8rem;
  line-height: 0.8rem;
  font-size: 0.37rem !important;
  text-align: center;
  border: 1px solid #7faa55;
  color: #7faa55;
  border-radius: 0.13rem;
  cursor: pointer;
}
.check-icon {
  background: rgb(127, 170, 85);
  font-size: 1.07rem !important;
  border-radius: 50%;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/bindState.vue